import React from 'react';
import { connect } from 'react-redux';
import { api } from 'utils/ajax';
import { showOptimisticPendingTransaction, fetchUploadTransactions } from 'ducks/uploadTransactions';
import { fetchTransaction } from 'ducks/details';
import { fetchTransactions } from 'ducks/list';
import { DataFilesManifestsDownloadContainer } from 'containers/DownloadContainers';
import Button from 'components/UIKit/Button/ButtonTemplate';
import { Row } from 'components/UIKit/Flex';
import withRouting from 'utils/withRouting';

let TransactionActions = ({
  tx,
  project,
  router,
  hasManifest,
  dataFileIds,
  headerId,
  dispatch,
}) => {
  return (
    <Row data-testid="table-transaction-actions" style={{ flexWrap: 'wrap' }}>
      {tx.state === 'SUCCEEDED' && tx.is_dry_run &&
      !tx.committed_by && !tx.closed &&
        <div>
          <Button
            customDataTestID="button-transaction-commit"
            disabled={!(project || { in_review: false }).in_review}
            onClick={() => {
              api({
                url: `${router.params.program}/${router.params.project}/transactions/${tx.id}/commit?async=true`,
                method: 'post',
              });
              dispatch(showOptimisticPendingTransaction());
            }}
          >
            commit
          </Button>
          &nbsp;
          <Button
            customDataTestID="button-transaction-discard"
            disabled={!(project || { in_review: false }).in_review}
            onClick={() => {
              api({
                url: `${router.params.program}/${router.params.project}/transactions/${tx.id}/close`,
                method: 'post',
              });
              dispatch(fetchTransaction({ id: tx.id }));
              dispatch(fetchTransactions({
                first: 10,
                offset: 0,
                sort: 'created_datetime',
                order: 'desc',
                program: router.params.program,
                project: router.params.project,
                ...router.location.query
              }));
              dispatch(fetchUploadTransactions({
                first: 10,
                offset: 0,
                sort: 'created_datetime',
                order: 'desc',
                program: router.params.program,
                project: router.params.project,
                ...router.location.query
              }));
            }}
          >
            discard
          </Button>
        </div>
      }
      {hasManifest &&
        <DataFilesManifestsDownloadContainer
          customDataTestID="button-download-transaction-manifest"
          dataFilesIds={dataFileIds}
          filename={`manifest_transaction_${headerId}.yml`}
        >
          Manifest
        </DataFilesManifestsDownloadContainer>
      }
      {!hasManifest && !(tx.state === 'SUCCEEDED' && tx.is_dry_run && !tx.committed_by) &&
        <div>No actions at this time</div>
      }
    </Row>
  );
};

export default connect()(withRouting(TransactionActions));
